import ContactListsIconSvg from '@/assets/svgs/main/contact-lists.svg';
import { AbbreviatedNumber } from '@/shared/components/AbbreviatedNumber';
import DetailsCard from '@/shared/components/DetailsCard';

interface ContactsCardProps {
  leadsRemaining: number;
  leadsLoaded: number;
  leadsSupplied: number;
  leadsInvalid: number;
  leadsDuplicate: number;
  leadsCellSuppressed: number;
}

export const ContactsCard = ({
  leadsRemaining,
  leadsLoaded,
  leadsSupplied,
  leadsInvalid,
  leadsDuplicate,
  leadsCellSuppressed,
}: ContactsCardProps) => {
  return (
    <div className="mb-6">
      <DetailsCard icon={<ContactListsIconSvg className="h-5 w-5" />} title="Contacts">
        <div className="grid grid-cols-3 gap-0">
          <div className="border-r border-gray-200 p-4 text-left dark:border-gray-800">
            <div className="text-sm text-gray-500">Remaining</div>
            <div className="text-3xl font-bold text-gray-900 dark:text-gray-300">
              <AbbreviatedNumber value={leadsRemaining} />
            </div>
          </div>
          <div className="border-r border-gray-200 p-4 text-left dark:border-gray-800">
            <div className="text-sm text-gray-500">Loaded</div>
            <div className="text-3xl font-bold text-gray-900 dark:text-gray-300">
              <AbbreviatedNumber value={leadsLoaded} />
            </div>
          </div>
          <div className="p-4 text-left">
            <div className="text-sm text-gray-500">Supplied</div>
            <div className="text-3xl font-bold text-gray-900 dark:text-gray-300">
              <AbbreviatedNumber value={leadsSupplied} />
            </div>
          </div>
          <div className="border-t border-r border-gray-200 p-4 text-left dark:border-gray-800">
            <div className="text-sm text-gray-500">Invalid</div>
            <div className="text-3xl font-bold text-gray-900 dark:text-gray-300">
              <AbbreviatedNumber value={leadsInvalid} />
            </div>
          </div>
          <div className="border-t border-r border-gray-200 p-4 text-left dark:border-gray-800">
            <div className="text-sm text-gray-500">Duplicate</div>
            <div className="text-3xl font-bold text-gray-900 dark:text-gray-300">
              <AbbreviatedNumber value={leadsDuplicate} />
            </div>
          </div>
          <div className="border-t border-gray-200 p-4 text-left dark:border-gray-800">
            <div className="text-sm text-gray-500">Suppressed</div>
            <div className="text-3xl font-bold text-gray-900 dark:text-gray-300">
              <AbbreviatedNumber value={leadsCellSuppressed} />
            </div>
          </div>
        </div>
      </DetailsCard>
    </div>
  );
};
